// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"26276197","876":"aced3e33"}[chunkId] + ".chunk.js";
};